import kamin1 from "../Assets/Hall/kamin1.jpg";
import kamin2 from "../Assets/Hall/kamin2.jpg";
import kamin3 from "../Assets/Hall/kamin3.jpg";
import kamin4 from "../Assets/Hall/kamin4.jpg";
import kamin5 from "../Assets/Hall/kamin5.jpg";
import kamin6 from "../Assets/Hall/kamin6.jpg";
import kamin7 from "../Assets/Hall/kamin7.jpg";
import kamin8 from "../Assets/Hall/kamin8.jpg";
import kamin9 from "../Assets/Hall/kamin9.jpg";
import kamin10 from "../Assets/Hall/kamin10.jpg";
import kamin11 from "../Assets/Hall/kamin11.jpg";
import kamin12 from "../Assets/Hall/kamin12.jpg";
import kamin13 from "../Assets/Hall/kamin13.jpg";
import kamin14 from "../Assets/Hall/kamin14.jpg";
import kamin15 from "../Assets/Hall/kamin15.jpg";
import kamin16 from "../Assets/Hall/kamin16.jpg";
import kamin17 from "../Assets/Hall/kamin17.jpg";
import kamin18 from "../Assets/Hall/kamin18.jpg";
import kamin19 from "../Assets/Hall/kamin19.jpg";
import kamin20 from "../Assets/Hall/kamin20.jpg";
import kamin21 from "../Assets/Hall/kamin21.jpg";
import kamin22 from "../Assets/Hall/kamin22.jpg";
import kamin23 from "../Assets/Hall/kamin23.jpg";
import kamin24 from "../Assets/Hall/kamin24.jpg";
import kamin25 from "../Assets/Hall/kamin25.jpg";
import kamin26 from "../Assets/Hall/kamin26.jpg";
import kamin27 from "../Assets/Hall/kamin27.jpg";
import kamin28 from "../Assets/Hall/kamin28.jpg";
import kamin29 from "../Assets/Hall/kamin29.jpg";
import kamin30 from "../Assets/Hall/kamin30.jpg";
import kamin31 from "../Assets/Hall/kamin31.jpg";
import kamin32 from "../Assets/Hall/kamin32.jpg";
import kamin33 from "../Assets/Hall/kamin33.jpg";
import kamin34 from "../Assets/Hall/kamin34.jpg";
import kamin35 from "../Assets/Hall/kamin35.jpg";
import kamin36 from "../Assets/Hall/kamin36.jpg";
import kamin37 from "../Assets/Hall/kamin37.jpg";
import kamin38 from "../Assets/Hall/kamin38.jpg";
import kamin39 from "../Assets/Hall/kamin39.jpg";
import kamin40 from "../Assets/Hall/kamin40.jpg";
import kamin41 from "../Assets/Hall/kamin41.jpg";
import kamin42 from "../Assets/Hall/kamin42.jpg";
import kamin43 from "../Assets/Hall/kamin43.jpg";
import kamin44 from "../Assets/Hall/kamin44.jpg";
import kamin45 from "../Assets/Hall/kamin45.jpg";
import kamin46 from "../Assets/Hall/kamin46.jpg";
import kamin47 from "../Assets/Hall/kamin47.jpg";
import kamin48 from "../Assets/Hall/kamin48.jpg";
import kamin49 from "../Assets/Hall/kamin49.jpg";
import kamin50 from "../Assets/Hall/kamin50.jpg";
import kamin51 from "../Assets/Hall/kamin51.jpg";
import kamin52 from "../Assets/Hall/kamin52.jpg";
import svecanaupdate1 from "../Assets/Hall/svecanaupdate1.jpg";
import svecanaupdate2 from "../Assets/Hall/svecanaupdate2.jpg";
import svecanaupdate3 from "../Assets/Hall/svecanaupdate3.jpg";
import svecanaupdate4 from "../Assets/Hall/svecanaupdate4.jpg";
import svecanaupdate5 from "../Assets/Hall/svecanaupdate5.jpg";
import svecanaupdate6 from "../Assets/Hall/svecanaupdate6.jpg";
import svecanaupdate7 from "../Assets/Hall/svecanaupdate7.jpg";
import svecanaupdate8 from "../Assets/Hall/svecanaupdate8.jpg";
import svecanaupdate9 from "../Assets/Hall/svecanaupdate9.jpg";
import svecanaupdate10 from "../Assets/Hall/svecanaupdate10.jpg";
import svecanaupdate11 from "../Assets/Hall/svecanaupdate11.jpg";
import svecanaupdate12 from "../Assets/Hall/svecanaupdate12.jpg";
import svecanaupdate13 from "../Assets/Hall/svecanaupdate13.jpg";
import svecanaupdate14 from "../Assets/Hall/svecanaupdate14.jpg";
import svecanaupdate15 from "../Assets/Hall/svecanaupdate15.jpg";
import svecanaupdate16 from "../Assets/Hall/svecanaupdate16.jpg";
import grande1 from "../Assets/Hall/grande1.jpg";
import grande2 from "../Assets/Hall/grande2.jpg";
import grande3 from "../Assets/Hall/grande3.jpg";
import grande4 from "../Assets/Hall/grande4.jpg";
import grande5 from "../Assets/Hall/grande5.jpg";
import grande6 from "../Assets/Hall/grande6.jpg";
import grande7 from "../Assets/Hall/grande7.jpg";
import grande8 from "../Assets/Hall/grande8.jpg";
import grande9 from "../Assets/Hall/grande9.jpg";
import grande10 from "../Assets/Hall/grande10.jpg";
import grande11 from "../Assets/Hall/grande11.jpg";
import grande12 from "../Assets/Hall/grande12.jpg";
import grande13 from "../Assets/Hall/grande13.jpg";
import grande14 from "../Assets/Hall/grande14.jpg";
import grande15 from "../Assets/Hall/grande15.jpg";
import grande16 from "../Assets/Hall/grande16.jpg";
import grande17 from "../Assets/Hall/grande17.jpg";
import grande18 from "../Assets/Hall/grande18.jpg";
import grande19 from "../Assets/Hall/grande19.jpg";
import grande20 from "../Assets/Hall/grande20.jpg";
import grande21 from "../Assets/Hall/grande21.jpg";
import grande22 from "../Assets/Hall/grande22.jpg";
import grande23 from "../Assets/Hall/grande23.jpg";
import grande24 from "../Assets/Hall/grande24.jpg";
import grande25 from "../Assets/Hall/grande25.jpg";
import grande26 from "../Assets/Hall/grande26.jpg";
import grande27 from "../Assets/Hall/grande27.jpg";
import grande28 from "../Assets/Hall/grande28.jpg";
import grande29 from "../Assets/Hall/grande29.jpg";
import grande30 from "../Assets/Hall/grande30.jpg";
import grande31 from "../Assets/Hall/grande31.jpg";
import grande32 from "../Assets/Hall/grande32.jpg";
import grande33 from "../Assets/Hall/grande33.jpg";
import grande34 from "../Assets/Hall/grande34.jpg";
import grande35 from "../Assets/Hall/grande35.jpg";
import grande36 from "../Assets/Hall/grande36.jpg";
import grande37 from "../Assets/Hall/grande37.jpg";
import grande38 from "../Assets/Hall/grande38.jpg";
import grande39 from "../Assets/Hall/grande39.jpg";
import grande40 from "../Assets/Hall/grande40.jpg";
import grande41 from "../Assets/Hall/grande41.jpg";
import grande42 from "../Assets/Hall/grande42.jpg";
import grande43 from "../Assets/Hall/grande43.jpg";
import grande44 from "../Assets/Hall/grande44.jpg";
import grande45 from "../Assets/Hall/grande45.jpg";
import grande46 from "../Assets/Hall/grande46.jpg";
import grande47 from "../Assets/Hall/grande47.jpg";
import grande48 from "../Assets/Hall/grande48.jpg";
import grande49 from "../Assets/Hall/grande49.jpg";
import grande50 from "../Assets/Hall/grande50.jpg";
import grande51 from "../Assets/Hall/grande51.jpg";
import grande52 from "../Assets/Hall/grande52.jpg";
import grande53 from "../Assets/Hall/grande53.jpg";
import grande54 from "../Assets/Hall/grande54.jpg";
import grande55 from "../Assets/Hall/grande55.jpg";
import grande56 from "../Assets/Hall/grande56.jpg";
import grande57 from "../Assets/Hall/grande57.jpg";
import grande58 from "../Assets/Hall/grande58.jpg";
import grande59 from "../Assets/Hall/grande59.jpg";
import grande60 from "../Assets/Hall/grande60.jpg";
import grande61 from "../Assets/Hall/grande61.jpg";
import grande62 from "../Assets/Hall/grande62.jpg";
import grande63 from "../Assets/Hall/grande63.jpg";
import grande64 from "../Assets/Hall/grande64.jpg";
import grande65 from "../Assets/Hall/grande65.jpg";
import grande66 from "../Assets/Hall/grande66.jpg";
import grande67 from "../Assets/Hall/grande67.jpg";
import grande68 from "../Assets/Hall/grande68.jpg";
import grande69 from "../Assets/Hall/grande69.jpg";
import grande70 from "../Assets/Hall/grande70.jpg";
import grande71 from "../Assets/Hall/grande71.jpg";
import grande72 from "../Assets/Hall/grande72.jpg";
import grande73 from "../Assets/Hall/grande73.jpg";
import grande74 from "../Assets/Hall/grande74.jpg";
import grande75 from "../Assets/Hall/grande75.jpg";
import grande76 from "../Assets/Hall/grande76.jpg";
import grande77 from "../Assets/Hall/grande77.jpg";
import grande78 from "../Assets/Hall/grande78.jpg";
import grande79 from "../Assets/Hall/grande79.jpg";
import grande80 from "../Assets/Hall/grande80.jpg";
import grande81 from "../Assets/Hall/grande81.jpg";
import grande82 from "../Assets/Hall/grande82.jpg";
import grande83 from "../Assets/Hall/grande83.jpg";
import grande84 from "../Assets/Hall/grande84.jpg";
import grande85 from "../Assets/Hall/grande85.jpg";
import grande86 from "../Assets/Hall/grande86.jpg";
import grande87 from "../Assets/Hall/grande87.jpg";
import grande88 from "../Assets/Hall/grande88.jpg";
import grande89 from "../Assets/Hall/grande89.jpg";
import grande90 from "../Assets/Hall/grande90.jpg";
import grande91 from "../Assets/Hall/grande91.jpg";
import grande92 from "../Assets/Hall/grande92.jpg";
import grande93 from "../Assets/Hall/grande93.jpg";
import grande94 from "../Assets/Hall/grande94.jpg";
import grande95 from "../Assets/Hall/grande95.jpg";
import grande96 from "../Assets/Hall/grande96.jpg";
import grande97 from "../Assets/Hall/grande97.jpg";
import grande98 from "../Assets/Hall/grande98.jpg";
import grande99 from "../Assets/Hall/grande99.jpg";
import grande100 from "../Assets/Hall/grande100.jpg";
import grande101 from "../Assets/Hall/grande101.jpg";
import grande102 from "../Assets/Hall/grande102.jpg";
import grande103 from "../Assets/Hall/grande103.jpg";
import grande104 from "../Assets/Hall/grande104.jpg";
import grande105 from "../Assets/Hall/grande105.jpg";
import grande106 from "../Assets/Hall/grande106.jpg";
import grande107 from "../Assets/Hall/grande107.jpg";
import grande108 from "../Assets/Hall/grande108.jpg";
import grande109 from "../Assets/Hall/grande109.jpg";
import grande110 from "../Assets/Hall/grande110.jpg";
import grande111 from "../Assets/Hall/grande111.jpg";
import grande112 from "../Assets/Hall/grande112.jpg";
import grande113 from "../Assets/Hall/grande113.jpg";
import gardenupdate1 from "../Assets/Hall/gardenupdate1.jpg";
import gardenupdate2 from "../Assets/Hall/gardenupdate2.jpg";
import gardenupdate3 from "../Assets/Hall/gardenupdate3.jpg";
import gardenupdate4 from "../Assets/Hall/gardenupdate4.jpg";
import gardenupdate5 from "../Assets/Hall/gardenupdate5.jpg";
import gardenupdate6 from "../Assets/Hall/gardenupdate6.jpg";
import gardenupdate7 from "../Assets/Hall/gardenupdate7.jpg";
import gardenupdate8 from "../Assets/Hall/gardenupdate8.jpg";

export const HallGalleryData = [
  {
    image: grande1,
    category: "grande",
  },
  {
    image: grande2,
    category: "grande",
  },
  {
    image: grande3,
    category: "grande",
  },
  {
    image: grande4,
    category: "grande",
  },
  {
    image: grande5,
    category: "grande",
  },
  {
    image: grande6,
    category: "grande",
  },
  {
    image: grande7,
    category: "grande",
  },
  {
    image: grande8,
    category: "grande",
  },
  {
    image: grande9,
    category: "grande",
  },
  {
    image: grande10,
    category: "grande",
  },
  {
    image: grande11,
    category: "grande",
  },
  {
    image: grande12,
    category: "grande",
  },
  {
    image: grande13,
    category: "grande",
  },
  {
    image: grande14,
    category: "grande",
  },
  {
    image: grande15,
    category: "grande",
  },
  {
    image: grande16,
    category: "grande",
  },
  {
    image: grande17,
    category: "grande",
  },
  {
    image: grande18,
    category: "grande",
  },
  {
    image: grande19,
    category: "grande",
  },
  {
    image: grande20,
    category: "grande",
  },
  {
    image: grande21,
    category: "grande",
  },
  {
    image: grande22,
    category: "grande",
  },
  {
    image: grande23,
    category: "grande",
  },
  {
    image: grande24,
    category: "grande",
  },
  {
    image: grande25,
    category: "grande",
  },
  {
    image: grande26,
    category: "grande",
  },
  {
    image: grande27,
    category: "grande",
  },
  {
    image: grande28,
    category: "grande",
  },
  {
    image: grande29,
    category: "grande",
  },
  {
    image: grande30,
    category: "grande",
  },
  {
    image: grande31,
    category: "grande",
  },
  {
    image: grande32,
    category: "grande",
  },
  {
    image: grande33,
    category: "grande",
  },
  {
    image: grande34,
    category: "grande",
  },
  {
    image: grande35,
    category: "grande",
  },
  {
    image: grande36,
    category: "grande",
  },
  {
    image: grande37,
    category: "grande",
  },
  {
    image: grande38,
    category: "grande",
  },
  {
    image: grande39,
    category: "grande",
  },
  {
    image: grande40,
    category: "grande",
  },
  {
    image: grande41,
    category: "grande",
  },
  {
    image: grande42,
    category: "grande",
  },
  {
    image: grande43,
    category: "grande",
  },
  {
    image: grande44,
    category: "grande",
  },
  {
    image: grande45,
    category: "grande",
  },
  {
    image: grande46,
    category: "grande",
  },
  {
    image: grande47,
    category: "grande",
  },
  {
    image: grande48,
    category: "grande",
  },
  {
    image: grande49,
    category: "grande",
  },
  {
    image: grande50,
    category: "grande",
  },
  {
    image: grande51,
    category: "grande",
  },
  {
    image: grande52,
    category: "grande",
  },
  {
    image: grande53,
    category: "grande",
  },
  {
    image: grande54,
    category: "grande",
  },
  {
    image: grande55,
    category: "grande",
  },
  {
    image: grande56,
    category: "grande",
  },
  {
    image: grande57,
    category: "grande",
  },
  {
    image: grande58,
    category: "grande",
  },
  {
    image: grande59,
    category: "grande",
  },
  {
    image: grande60,
    category: "grande",
  },
  {
    image: grande61,
    category: "grande",
  },
  {
    image: grande62,
    category: "grande",
  },
  {
    image: grande63,
    category: "grande",
  },
  {
    image: grande64,
    category: "grande",
  },
  {
    image: grande65,
    category: "grande",
  },
  {
    image: grande66,
    category: "grande",
  },
  {
    image: grande67,
    category: "grande",
  },
  {
    image: grande68,
    category: "grande",
  },
  {
    image: grande69,
    category: "grande",
  },
  {
    image: grande70,
    category: "grande",
  },
  {
    image: grande71,
    category: "grande",
  },
  {
    image: grande72,
    category: "grande",
  },
  {
    image: grande73,
    category: "grande",
  },
  {
    image: grande74,
    category: "grande",
  },
  {
    image: grande75,
    category: "grande",
  },
  {
    image: grande76,
    category: "grande",
  },
  {
    image: grande77,
    category: "grande",
  },
  {
    image: grande78,
    category: "grande",
  },
  {
    image: grande79,
    category: "grande",
  },
  {
    image: grande80,
    category: "grande",
  },
  {
    image: grande81,
    category: "grande",
  },
  {
    image: grande82,
    category: "grande",
  },
  {
    image: grande83,
    category: "grande",
  },
  {
    image: grande84,
    category: "grande",
  },
  {
    image: grande85,
    category: "grande",
  },
  {
    image: grande86,
    category: "grande",
  },
  {
    image: grande87,
    category: "grande",
  },
  {
    image: grande88,
    category: "grande",
  },
  {
    image: grande89,
    category: "grande",
  },
  {
    image: grande90,
    category: "grande",
  },
  {
    image: grande91,
    category: "grande",
  },
  {
    image: grande92,
    category: "grande",
  },
  {
    image: grande93,
    category: "grande",
  },
  {
    image: grande94,
    category: "grande",
  },
  {
    image: grande95,
    category: "grande",
  },
  {
    image: grande96,
    category: "grande",
  },
  {
    image: grande97,
    category: "grande",
  },
  {
    image: grande98,
    category: "grande",
  },
  {
    image: grande99,
    category: "grande",
  },
  {
    image: grande100,
    category: "grande",
  },
  {
    image: grande101,
    category: "grande",
  },
  {
    image: grande102,
    category: "grande",
  },
  {
    image: grande103,
    category: "grande",
  },
  {
    image: grande104,
    category: "grande",
  },
  {
    image: grande105,
    category: "grande",
  },
  {
    image: grande106,
    category: "grande",
  },
  {
    image: grande107,
    category: "grande",
  },
  {
    image: grande108,
    category: "grande",
  },
  {
    image: grande109,
    category: "grande",
  },
  {
    image: grande110,
    category: "grande",
  },
  {
    image: grande111,
    category: "grande",
  },
  {
    image: grande112,
    category: "grande",
  },
  {
    image: grande113,
    category: "grande",
  },
  {
    image: svecanaupdate1,
    category: "svečana",
  },
  {
    image: svecanaupdate2,
    category: "svečana",
  },
  {
    image: svecanaupdate3,
    category: "svečana",
  },
  {
    image: svecanaupdate4,
    category: "svečana",
  },
  {
    image: svecanaupdate5,
    category: "svečana",
  },
  {
    image: svecanaupdate6,
    category: "svečana",
  },
  {
    image: svecanaupdate7,
    category: "svečana",
  },
  {
    image: svecanaupdate8,
    category: "svečana",
  },
  {
    image: svecanaupdate9,
    category: "svečana",
  },
  {
    image: svecanaupdate10,
    category: "svečana",
  },
  {
    image: svecanaupdate11,
    category: "svečana",
  },
  {
    image: svecanaupdate12,
    category: "svečana",
  },
  {
    image: svecanaupdate13,
    category: "svečana",
  },
  {
    image: svecanaupdate14,
    category: "svečana",
  },
  {
    image: svecanaupdate15,
    category: "svečana",
  },
  {
    image: svecanaupdate16,
    category: "svečana",
  },
  {
    image: kamin1,
    category: "kamin",
  },
  {
    image: kamin2,
    category: "kamin",
  },
  {
    image: kamin3,
    category: "kamin",
  },
  {
    image: kamin4,
    category: "kamin",
  },
  {
    image: kamin5,
    category: "kamin",
  },
  {
    image: kamin6,
    category: "kamin",
  },
  {
    image: kamin7,
    category: "kamin",
  },
  {
    image: kamin8,
    category: "kamin",
  },
  {
    image: kamin9,
    category: "kamin",
  },
  {
    image: kamin10,
    category: "kamin",
  },
  {
    image: kamin11,
    category: "kamin",
  },
  {
    image: kamin12,
    category: "kamin",
  },
  {
    image: kamin13,
    category: "kamin",
  },
  {
    image: kamin14,
    category: "kamin",
  },
  {
    image: kamin15,
    category: "kamin",
  },
  {
    image: kamin16,
    category: "kamin",
  },
  {
    image: kamin17,
    category: "kamin",
  },
  {
    image: kamin18,
    category: "kamin",
  },
  {
    image: kamin19,
    category: "kamin",
  },
  {
    image: kamin20,
    category: "kamin",
  },
  {
    image: kamin21,
    category: "kamin",
  },
  {
    image: kamin22,
    category: "kamin",
  },
  {
    image: kamin23,
    category: "kamin",
  },
  {
    image: kamin24,
    category: "kamin",
  },
  {
    image: kamin25,
    category: "kamin",
  },
  {
    image: kamin26,
    category: "kamin",
  },
  {
    image: kamin27,
    category: "kamin",
  },
  {
    image: kamin28,
    category: "kamin",
  },
  {
    image: kamin29,
    category: "kamin",
  },
  {
    image: kamin30,
    category: "kamin",
  },
  {
    image: kamin31,
    category: "kamin",
  },
  {
    image: kamin32,
    category: "kamin",
  },
  {
    image: kamin33,
    category: "kamin",
  },
  {
    image: kamin34,
    category: "kamin",
  },
  {
    image: kamin35,
    category: "kamin",
  },
  {
    image: kamin36,
    category: "kamin",
  },
  {
    image: kamin37,
    category: "kamin",
  },
  {
    image: kamin38,
    category: "kamin",
  },
  {
    image: kamin39,
    category: "kamin",
  },
  {
    image: kamin40,
    category: "kamin",
  },
  {
    image: kamin41,
    category: "kamin",
  },
  {
    image: kamin42,
    category: "kamin",
  },
  {
    image: kamin43,
    category: "kamin",
  },
  {
    image: kamin44,
    category: "kamin",
  },
  {
    image: kamin45,
    category: "kamin",
  },
  {
    image: kamin46,
    category: "kamin",
  },
  {
    image: kamin47,
    category: "kamin",
  },
  {
    image: kamin48,
    category: "kamin",
  },
  {
    image: kamin49,
    category: "kamin",
  },
  {
    image: kamin50,
    category: "kamin",
  },
  {
    image: kamin51,
    category: "kamin",
  },
  {
    image: kamin52,
    category: "kamin",
  },
  {
    image: gardenupdate1,
    category: "garden",
  },
  {
    image: gardenupdate2,
    category: "garden",
  },
  {
    image: gardenupdate3,
    category: "garden",
  },
  {
    image: gardenupdate4,
    category: "garden",
  },
  {
    image: gardenupdate5,
    category: "garden",
  },
  {
    image: gardenupdate6,
    category: "garden",
  },
  {
    image: gardenupdate7,
    category: "garden",
  },
  {
    image: gardenupdate8,
    category: "garden",
  },
];
